export const BREADCRUMB_MAX_CONTENT_WIDTH = 71

export const QA_NAME_BREADCRUMB_PAGE_TITLE = 'PageTitle'

export const QA_NAME_BREADCRUMB = 'breadcrumb'

export const BREADCRUMB_VARIANT = {
  DEFAULT: 'default',
  TAB: 'tab',
}
